import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { translate } from 'helpers/intl';
import messages from 'containers/AutoDetailsPage/messages';
import { AssuranceIcon } from 'images';
import { sanlamVeryDarkBlue } from 'Material-UI/colors';
import {
  StyledCaptions,
  ItemWrapper,
  SizedSmallSectionHeader,
  SizedGridItem,
} from 'containers/AutoDetailsPage/MyContractsBloc/DownloadFileAutoContracts/styles';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';

const DownloadFileAutoContracts = (props: {
  intl: IntlShape;
  category: string;
  files: {
    uri: string;
    category: string;
  }[];
}) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const ANALYTICS = {
    formule_assistance:
      "Mes contrats et garantiesTélécharger_Formules d'assistance",
    conditions_generales:
      'Mes contrats et garanties_Mes documents à télécharger_CGU',
  };
  return (
    <>
      {props.files && (
        <Grid container>
          <Grid xs={12} item>
            <SizedSmallSectionHeader color={sanlamVeryDarkBlue} weight="bold">
              {translate({ ...messages.DownloadFileTitle }, props)}
            </SizedSmallSectionHeader>
          </Grid>
          {props.files.map((item: any, index) => (
            <SizedGridItem item key={index}>
              <GaClickHOC
                category={props.category}
                label={get(ANALYTICS, item.category)}
              >
                <ItemWrapper
                  data-testid={`download-file-${index}`}
                  onClick={() => global.open(item.uri)}
                >
                  <img alt="downloadIcon" src={AssuranceIcon['downloadIcon']} />
                  <StyledCaptions reverse={reverse}>
                    {translate(get(messages, item.category), props)}
                  </StyledCaptions>
                </ItemWrapper>
              </GaClickHOC>
            </SizedGridItem>
          ))}
        </Grid>
      )}
    </>
  );
};
export default injectIntl(DownloadFileAutoContracts);
